import PropTypes from 'prop-types'
import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import { Link } from "react-router-dom"

//import drawer
import ReactDrawer from 'react-drawer';
import 'react-drawer/lib/react-drawer.css';

//Import Icons

// Import menuDropdown
import NotificationDropdown from "../CommonForBoth/TopbarDropdown/NotificationDropdown"
import ProfileMenu from "../CommonForBoth/TopbarDropdown/ProfileMenu"
import RightSidebar from "../CommonForBoth/RightSidebar"
// import LightDark from "../CommonForBoth/Menus/LightDark";

//i18n
import { withTranslation } from "react-i18next"

// Redux Store
import {
  showRightSidebarAction,
  toggleLeftmenu,
  changeSidebarType,
  changelayoutMode
} from "../../store/actions"
import { MainSearchBox, } from '../Common/SearchBox/index';
import { MySearch } from '../Common/SearchBox/MySearch';
import { GET_COMPANY_FROM_URL, GET_ERP_IMG, IsSweetAndSnacksCompany, loginSystemSetting } from '../Common/CommonFunction';
import { Modal } from 'reactstrap';
import { Fetch_Generic_Message_API, Notification_Log } from '../../helpers/backend_helper';

const Header = props => {
  const { onChangeLayoutMode } = props;
  const [search, setsearch] = useState(false)
  const [isClick, setClick] = useState(true);
  const [position, setPosition] = useState();
  const [open, setOpen] = useState(false);
  const [modal_backdrop, setmodal_backdrop] = useState(false);   // Image Model open Or not
  const [notification, setNotification] = useState("");
  const isSweetAndSnacksCompany = IsSweetAndSnacksCompany()
  const onDrawerClose = () => {
    setOpen(false);
  }



  // ✅ 2. Fetch + filter + set notification correctly
  useEffect(() => {
    const alreadyFetched = sessionStorage.getItem("GenericMessageFetched");
    const existingSetting = JSON.parse(sessionStorage.getItem("SystemSetting")) || {};

    // ✅ If already fetched → use cached
    if (alreadyFetched === "true") {
      const cachedMessage = sessionStorage.getItem("GenericMessage");

      if (cachedMessage && cachedMessage !== "null") {
        setNotification(cachedMessage);
      }

      return; // 🚀 STOP API CALL
    }

    const value = existingSetting.IsNotificationShow;

    // ❌ Don't call API
    if (value === 0 || value === "0") return;

    const loadNotification = async () => {
      try {
        const response = await Fetch_Generic_Message_API({
          jsonBody: JSON.stringify({
            ActiveMessages: 0,
            Party: 0,
          }),
        });

        const messages = response.Data || [];
        const now = new Date();

        const selectedParty = JSON.parse(localStorage.getItem(`${GET_COMPANY_FROM_URL()}_selectedParty`))?.value;
        const roleData = JSON.parse(localStorage.getItem(`${GET_COMPANY_FROM_URL()}_roleId`));
        const userRole = roleData?.Role;
        const companyId = Number(localStorage.getItem(`${GET_COMPANY_FROM_URL()}_Company`));

        const validMessage = messages
          .filter(m => {
            const from = new Date(m.ValidFrom);
            const to = new Date(m.ValidTo);

            return (
              m.IsActive &&
              from <= now &&
              to >= now &&
              (!m.CompanyID || m.CompanyID === companyId) &&
              (!m.Party || m.Party === selectedParty) &&
              (!m.Role || m.Role.split(",").map(Number).includes(userRole))
            );
          })
          .sort((a, b) => new Date(b.ValidFrom) - new Date(a.ValidFrom))[0];

        const Message = validMessage ? `<p>${validMessage.MessageText}</p>` : null;

        if (Message && Message !== "null") {
          setNotification(Message);
          sessionStorage.setItem("GenericMessage", Message);
        } else {
          setNotification(null);
          sessionStorage.removeItem("GenericMessage");
        }
        sessionStorage.setItem("GenericMessageFetched", "true");
      } catch (error) {
        console.error("Notification load error", error);
      }
    };

    loadNotification();

  }, []);


  function tog_backdrop() {
    setmodal_backdrop(!modal_backdrop)
    removeBodyCss()
  }
  function removeBodyCss() {
    document.body.classList.add("no_padding")
  }
  /*** Sidebar menu icon and default menu set */
  function tToggle() {

    var body = document.body;
    setClick(!isClick);
    if (isClick === true) {
      body.classList.add("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'sm');
    } else {
      body.classList.remove("sidebar-enable");
      document.body.setAttribute('data-sidebar-size', 'lg');
    }
  }
  // Check the window width on the first load and set the initial state of isClick
  useEffect(() => {
    function handleResize() {
      setClick(window.innerWidth >= 768); // Set isClick to true if the window width is greater than or equal to 768, otherwise set it to false
    }
    window.addEventListener('resize', handleResize);
    handleResize(); // Call it on the first load

    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const isSidebarSmall = isSweetAndSnacksCompany && !isClick;
  const handleClick = async () => {
    const SelectedPartyID = JSON.parse(localStorage.getItem(`${GET_COMPANY_FROM_URL()}_selectedParty`)).value
    const jsonBody =
    {
      "PartyID": SelectedPartyID,
      "TransactionID": 0,
      "FromDate": "",
      "ToDate": "",
      "CustomerID": 0

    }
    setmodal_backdrop(true);
    await Notification_Log({ jsonBody });
  };

  return (
    <React.Fragment>
      <header id="page-topbar">
        <Modal
          isOpen={modal_backdrop}
          toggle={() => {
            tog_backdrop()
          }}
          style={{ width: "800px", height: "800px", borderRadius: "50%" }}
          className="modal-dialog-centered"
        >
          {/* <div className="modal-content">
            <div className="modal-body">
              <p style={{ fontSize: "15px", color: "black" }}>
                <h5> All FoodERP users</h5>

                Following are the changes in FoodERP in view of commencement of new financial year (2025-26) on 1st April 2025.<br /><br />
                1 - On 31st March 2025 after completion of all work or if updating stock on 1st April 2025 select date 31st March 2025 to update closing stock. (Billing will not be possible on 1st April 2025 without stock update)<br /><br />
                2 - After the stock update dated 31st March 2025 no old transactions can be changed.<br /><br />
                3 - All transaction document numbers will start from 001. (Eg Bill Number, Credit Note Number…. )<br /><br />
              </p>
            </div>

          </div> */}



          {notification && (
            <div
              className="modal-content p-4 rounded"
              style={{ maxWidth: "700px", margin: "auto", backgroundColor: "#fff" }}
            >
              <div className="modal-body">
                <div
                  dangerouslySetInnerHTML={{ __html: notification }}
                  style={{
                    color: "#333",
                    lineHeight: "1.6",
                    fontSize: "15px",
                  }}
                />
                {/* Extra fix for bullets */}
                <style>
                  {`

            .modal-body p {
            text-align: left;
            margin-top: 7px;
            }

          .modal-body ul {
          margin-top: 20px;
            padding-left: 10px; 
            list-style-type: disc; 
          }
          .modal-body li {
            margin-bottom: 8px;
          }
        `}
                </style>
              </div>
            </div>
          )}







        </Modal>
        <div className="navbar-header">

          <div className="d-flex">
            <div className="navbar-brand-box" >
              <div style={{ cursor: "context-menu" }} className="logo logo-dark">
                <span className="logo-sm" >
                  <img src={GET_ERP_IMG().Logo} alt="" height="40" style={{ height: isSidebarSmall ? "41px" : "56px", marginLeft: isSidebarSmall ? "-20px" : "0px" }} />
                </span>
                <span className="logo-lg">
                  <img src={GET_ERP_IMG().Logo} alt="" height="40" style={{ height: isSweetAndSnacksCompany ? "46px" : "56px", borderRadius: "8px" }} /> <span className="logo-txt" style={{ color: 'white' }}>FoodERP 2.0</span>
                </span>
              </div>

              <Link to="/dashboard" className="logo logo-light">
                <span className="logo-sm" >
                  <img src={GET_ERP_IMG().Logo} alt="" height="35" style={{ height: isSweetAndSnacksCompany ? "46px" : "56px", borderRadius: "8px" }} />
                </span>
                <span className="logo-lg">
                  <img src={GET_ERP_IMG().Logo} alt="" height="35" style={{ height: isSweetAndSnacksCompany ? "46px" : "56px", borderRadius: "8px" }} /> <span className="logo-txt">FoodERP 2.0</span>
                </span>
              </Link>
            </div>
            <div>
              <button
                onClick={() => {
                  tToggle()
                }}
                type="button" className="btn btn-sm  font-size-16 header-item" id="vertical-menu-btn">
                <i className="fa fa-fw fa-bars"></i>
              </button>
            </div>
            <MainSearchBox />

          </div>
          {/* 
          {IsNotificationShow !== "null" ? <div style={{ fontWeight: "bold", cursor: "pointer" }} >
            <h3 style={{ color: "red" }} onClick={handleClick} class="text-red blink-soft">Important Notification! Click here</h3>
          </div> : null} */}


          {notification && notification !== "null" && notification !== "" && (
            <div style={{ fontWeight: "bold", cursor: "pointer" }}>
              <h3
                style={{ color: "red" }}
                onClick={handleClick}
                className="text-red blink-soft"
              >
                Important Notification! Click here
              </h3>
            </div>
          )}



          <div className="d-flex">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                onClick={() => {
                  setsearch(!search)
                }}
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  search
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <div className=" d-flex position-relative">
                  <MySearch isButton={true} />
                </div>

              </div>
            </div>

            <NotificationDropdown />
            <ProfileMenu />

          </div>


        </div>
      </header>
      <ReactDrawer
        open={open}
        position={position}
        onClose={onDrawerClose}
      >
        <RightSidebar onClose={onDrawerClose} onChangeLayoutMode={onChangeLayoutMode} />
      </ReactDrawer>
    </React.Fragment>
  )
}

Header.propTypes = {
  changeSidebarType: PropTypes.func,
  leftMenu: PropTypes.any,
  leftSideBarType: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
  changelayoutMode: PropTypes.func,
  layoutMode: PropTypes.any,
}

const mapStatetoProps = state => {
  const {
    layoutType,
    showRightSidebar,
    leftMenu,
    leftSideBarType,
    layoutMode
  } = state.Layout
  return { layoutType, showRightSidebar, leftMenu, leftSideBarType, layoutMode }
}

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  changelayoutMode,
  toggleLeftmenu,
  changeSidebarType,
})(withTranslation()(Header))
